<template>
    <input-wrapper
        class="single-checkbox-input"
        v-bind="{ state, helpText }"
    >
        <template #default="{ id }">
            <b-form-checkbox
                v-model="inputValue"
                v-bind="{ state, name, id, required, autocomplete }"
                :unchecked-value="null"
                :value="checkedValue || true"
            >
                <slot>
                    {{ label }}
                </slot>
            </b-form-checkbox>
        </template>
    </input-wrapper>
</template>

<script>
    import InputWrapper from '../InputWrapper/InputWrapper';
    import { BFormCheckbox } from 'bootstrap-vue';
    import InputBase from '../InputBase.mixin';

    export default {
        name: 'single-checkbox-input',

        components: {
            InputWrapper,
            BFormCheckbox,
        },

        mixins: [InputBase],
    };
</script>

<style lang="scss" scoped>
    @import "~bootstrap/scss/input-group";
    @import "~bootstrap/scss/forms";

    ::v-deep {
        @import "~bootstrap/scss/custom-forms";
        @import "~bootstrap-vue/src/components/form-checkbox";

        .custom-control-label {
            padding-top: rem(4px);
            font-size: rem(13px);
            color: secondary-palette(5);
            line-height: rem(16px);
        }
    }
</style>
